import  { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk'
import allReducers from '../redux/reducers'

// const store = createStore(allReducers , applyMiddleware(thunk), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(allReducers, /* preloadedState, */ composeEnhancers(
    applyMiddleware(thunk)
    ));


    export default store